import { render } from "./tags.vue?vue&type=template&id=2a974636"
import script from "./tags.vue?vue&type=script&lang=js"
export * from "./tags.vue?vue&type=script&lang=js"

import "./tags.vue?vue&type=style&index=0&id=2a974636&lang=css"

import exportComponent from "E:\\newwww\\weimj\\agency\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__